var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserCircle = function SvgIconUserCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.738 19.39A9.97 9.97 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.97 9.97 0 0 0 3.36 7.478A9.96 9.96 0 0 0 12 22a9.96 9.96 0 0 0 6.738-2.61M12 4a8 8 0 0 0-6.183 13.077 7.75 7.75 0 0 1 2.933-2.363 4.75 4.75 0 1 1 6.5 0 7.75 7.75 0 0 1 2.933 2.363A8 8 0 0 0 12 4m4.718 14.462a5.75 5.75 0 0 0-9.435 0A7.96 7.96 0 0 0 12 20a7.96 7.96 0 0 0 4.718-1.538M12.045 14a2.75 2.75 0 1 0-.09 0h.09",
    clipRule: "evenodd"
  })));
};
export default SvgIconUserCircle;